import { Injectable } from '@angular/core';

import { WeatherData, WeatherDataSingle } from '@models/module/fields/main';
import { HttpService } from '@shared/services';

@Injectable({ providedIn: 'root' })
export class WeatherTableService {
  route: string = '_api/weather';
  constructor(private httpService: HttpService) {}

  getDataByTimeAndLocation(
    associatedDate: string,
    associatedLocation: number,
    weatherTableId?: number,
    entityInstanceId?: number,
  ) {
    return this.httpService.post<WeatherDataSingle>(
      `${this.route}/GetDataByTimeAndLocation`,
      {
        associatedDate,
        associatedLocation,
        weatherTableId,
        entityInstanceId,
      },
      { useLoader: false },
    );
  }

  getDataByTimesAndLocation(times: string[], weatherTableId?: number, associatedLocation?: number) {
    return this.httpService.post<WeatherData>(
      `${this.route}/GetDataByTimesAndLocation`,
      {
        associatedLocation,
        weatherTableId,
        times,
      },
      { useLoader: false },
    );
  }

  getInstancesData(
    weatherTableId: number,
    entityInstanceId: number,
    actionInstanceId: number,
    associatedDate?: string,
    associatedLocation?: number,
  ) {
    return this.httpService.post<WeatherData>(
      `${this.route}/GetInstancesData`,
      {
        associatedDate,
        associatedLocation,
        weatherTableId,
        entityInstanceId,
        actionInstanceId,
      },
      { useLoader: false },
    );
  }
}
